export const WORKSPACE_CHANNEL = 'bankari-workspaces-v1';
export const MAX_WORKSPACE_TABS = 5;
export const WORKSPACE_MODULES = [
  { name: 'KartaKlienti', label: 'Klienti', icon: 'users', detail: 'Kontakty a rozpracované prípady' },
  { name: 'KartaHypoteky', label: 'Hypotéky', icon: 'briefcase', detail: 'Hypotéky, ponuky a žiadosti' },
  { name: 'KartaServis', label: 'Servis', icon: 'clock', detail: 'Refixácie a starostlivosť o klientov' },
  { name: 'KartaZiadosti', label: 'Žiadosti', icon: 'clipboard', detail: 'Prehľad žiadostí' },
  { name: 'KartaPosudky', label: 'Posudky', icon: 'book', detail: 'Znalecké posudky' },
  { name: 'KartaMarketing', label: 'Marketing', icon: 'megaphone', detail: 'Reklamy, články a sociálne siete' },
  { name: 'KartaNastavenia', label: 'Nastavenia', icon: 'settings', detail: 'Nastavenia aplikácie' },
];
export function safeWorkspaceRoute(path) {
  return typeof path === 'string' && path.length <= 5000 && /^\/(?!\/)/.test(path)
    && !/[\r\n]/.test(path) && !/^\/login(?:[/?#]|$)/.test(path) ? path : null;
}
export function isWorkspaceFrame(win) {
  try { return win.parent !== win && win.parent.location.origin === win.location.origin
    && new URL(win.location.href).searchParams.get('bankariWorkspace') === '1'; }
  catch { return false; }
}
export function initialWorkspaceRoute(win) {
  const url = new URL(win.location.href); url.searchParams.delete('bankariWorkspace'); url.searchParams.delete('bankariWorkspaceVersion');
  return url.pathname + url.search + url.hash;
}
export function workspaceFrameUrl(origin, path) {
  const url = new URL(path, origin); url.searchParams.set('bankariWorkspace', '1');
  // A new bundle must load the matching iframe document, even in an installed PWA.
  const version = typeof __webpack_hash__ === 'undefined' ? 'development' : __webpack_hash__;
  url.searchParams.set('bankariWorkspaceVersion', version); return url.href;
}
export function workspaceLabel(route) {
  if (route.name === 'KartaHypotekyDetail') return `Hypotéka ${route.params.hypoteka}`;
  return WORKSPACE_MODULES.find(item => item.name === route.name)?.label || 'Bankári';
}
export function workspaceStorageKey(id) { return `bankari-workspaces:v1:${id}`; }
export function serializeWorkspace(tabs, activeId, publicRoute) {
  return JSON.stringify({tabs: tabs.slice(0, MAX_WORKSPACE_TABS).map(({id, route}) => ({id, route})), activeId, publicRoute});
}
export function restoreWorkspace(raw, allowed) {
  try {
    const state = JSON.parse(raw), ids = new Set();
    if (!Array.isArray(state.tabs)) return null;
    const tabs = state.tabs.slice(0, MAX_WORKSPACE_TABS).filter(tab => {
      if (!tab || typeof tab.id !== 'string' || !/^[a-zA-Z0-9-]{1,80}$/.test(tab.id) || ids.has(tab.id)) return false;
      if (tab.route !== null && (!safeWorkspaceRoute(tab.route) || !allowed(tab.route))) return false;
      ids.add(tab.id); return true;
    }).map(({id, route}) => ({id, route}));
    if (!tabs.length) return null;
    return {tabs, activeId: tabs.some(tab => tab.id === state.activeId) ? state.activeId : tabs[0].id, publicRoute: safeWorkspaceRoute(state.publicRoute)};
  } catch { return null; }
}
// Vue Router 3's abstract history belongs to one iframe, never to a hidden sibling.
export function setupWorkspaceHistory(router) {
  const history = router.history;
  if (router.mode !== 'abstract') return;
  const replace = history.replace.bind(history);
  history.replace = (location, complete, abort) => {
    const position = history.index, forward = history.stack.slice(position + 1);
    replace(location, route => {
      if (history.index === position) history.stack.push(...forward);
      if (complete) complete(route);
    }, abort);
  };
}
export function workspaceNavigationState(router) {
  if (router.mode !== 'abstract') return {canGoBack: false, canGoForward: false};
  return {canGoBack: router.history.index > 0, canGoForward: router.history.index >= 0 && router.history.index < router.history.stack.length - 1};
}
function parentShell(win) {
  try { return isWorkspaceFrame(win) ? win.parent.__bankariWorkspaceShell : null; } catch { return null; }
}
export function authenticatedWorkspaceUser(win) { return parentShell(win)?.getAuthenticatedUser?.(win) || null; }
export function refreshWorkspaceAccess(request, win = window) {
  return parentShell(win)?.refreshSession?.(win) || request();
}
export function componentHasDirtyForm(vm) {
  if (!vm || vm._isDestroyed) return false;
  for (const key of ['dirty', 'isDirty', 'hasUnsavedChanges', 'saving', 'uploading']) {
    if ((Object.prototype.hasOwnProperty.call(vm.$data || {}, key) || vm.$options?.computed?.[key]) && vm[key] === true) return true;
  }
  return (vm.$children || []).some(componentHasDirtyForm);
}
export function frameHasUnsavedChanges(win) {
  const event = new win.Event('beforeunload', {cancelable: true});
  win.dispatchEvent(event);
  return event.defaultPrevented || win.__bankariWorkspaceFrame?.hasDirtyForm?.() === true;
}
